import { render } from "./board.vue?vue&type=template&id=7b6f82be&scoped=true"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"

import "./board.vue?vue&type=style&index=0&id=7b6f82be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b6f82be"

export default script